import { render } from "./Suporte.vue?vue&type=template&id=54553d7b&scoped=true"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"

import "./Suporte.vue?vue&type=style&index=0&id=54553d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54553d7b"]])

export default __exports__